import { Redirect, Route } from 'react-router-dom';

import PrivateRoute from '@Components/app-layout/PrivateRoute';
import AppRouter from '@Components/app-layout/Router';
import { useGlobalAuthStore } from '@Stores/global/auth';

import AllocationLayout from './views/allocation/Layout';
import AuditLayout from './views/audit/Layout';
import BucketLayout from './views/bucket/Layout';
import CustomLayout from './views/custom/Layout';
import FailureLayout from './views/failure/Layout';
import ImpressionDrilldown from './views/impression/Drilldown';
import ImpressionLayout from './views/impression/Layout';
import ImpressionPivotTableLayout from './views/impression-pivot-table';
import InquiryLayout from './views/inquiry/Layout';
import IntegrationDrilldownLayout from './views/integration/Drilldown';
import IntegrationLayout from './views/integration/Layout';
import LossesDrilldown from './views/losses/Drilldown';
import LossesLayout from './views/losses/Layout';
import OptoutLayout from './views/optout/Layout';
import OptoutSummaryLayout from './views/optout-summary/Layout';
import PathFinderLayout from './views/pathFinder/Layout';
import PingCheckDrilldownLayout from './views/ping-check/Drilldown';
import PingCheckLayout from './views/ping-check/Layout';
import ProgressionLayout from './views/progression/Layout';
import RewardsLayout from './views/rewards/Layout';
import SessionLayout from './views/session/Layout';
import SessionPivotTableLayout from './views/session-pivot-table';
import SiteVerificationDrilldown from './views/site-verification/Drilldown';
import SiteVerificationLayout from './views/site-verification/Layout';
import SurveysDrilldownLayout from './views/surveys/Drilldown';
import SurveysLayout from './views/surveys/Layout';
import SweepWinnerLayout from './views/sweep-winner/Layout';

export default function ReportRoutes({ hasPermission }) {
  const { auth: { isSuperAdmin } } = useGlobalAuthStore()
  const defaultRoute = hasPermission('path') ? '/reports/impression' : hasPermission('offer') ? '/reports/session' : '/';
  return <AppRouter redirect={defaultRoute}>
    {hasPermission('path') && <PrivateRoute path="/reports/impression/drilldown" exact component={ImpressionDrilldown} />}
    {hasPermission('path') && <PrivateRoute path="/reports/bucket" exact component={BucketLayout} />}
    {hasPermission('path') && <PrivateRoute path="/reports/impression" component={ImpressionLayout} />}
    {hasPermission('path') && <PrivateRoute path="/reports/audit" component={AuditLayout} />}
    {hasPermission('path') && <PrivateRoute path="/reports/progression" component={ProgressionLayout} />}
    {hasPermission('path') && <PrivateRoute path="/reports/finder" component={PathFinderLayout} />}
    {hasPermission('path') && <PrivateRoute path="/reports/failure" component={FailureLayout} />}
    {hasPermission('offer') && <PrivateRoute path="/reports/session" component={SessionLayout} />}
    {hasPermission('offer') && <PrivateRoute path="/reports/allocation" component={AllocationLayout} />}
    {hasPermission('offer') && <PrivateRoute path={["/reports/publisher-performance/drilldown", "/reports/organization-performance/drilldown"]} exact component={LossesDrilldown} />}
    {hasPermission('offer') && <PrivateRoute path="/reports/publisher-performance" component={LossesLayout} />}
    {hasPermission('offer') && <PrivateRoute path="/reports/organization-performance" component={OrganizationPerformanceLayout} />}
    <LegacyPathRedirect path="/reports/losses" to="/reports/publisher-performance" />
    <LegacyPathRedirect path="/reports/organization-losses" to="/reports/organization-performance" />
    {hasPermission('cms') && <PrivateRoute path="/reports/optouts" component={OptoutLayout} />}
    {hasPermission('path') && <PrivateRoute path="/reports/inquiry" component={InquiryLayout} />}
    {hasPermission('cms') && <PrivateRoute path="/reports/optout-summary" component={OptoutSummaryLayout} />}
    {hasPermission('path') && <PrivateRoute path="/reports/surveys/drilldown" exact component={SurveysDrilldownLayout} />}
    {hasPermission('path') && <PrivateRoute path="/reports/surveys" component={SurveysLayout} />}
    {hasPermission('path') && <PrivateRoute path="/reports/integration/drilldown" exact component={IntegrationDrilldownLayout} />}
    {hasPermission('path') && <PrivateRoute path="/reports/integration" component={IntegrationLayout} />}
    {hasPermission('offer') && <PrivateRoute path="/reports/site-verification/drilldown" exact component={SiteVerificationDrilldown} />}
    {hasPermission('offer') && <PrivateRoute path="/reports/site-verification" component={SiteVerificationLayout} />}
    {hasPermission('offer') && <PrivateRoute path="/reports/sweep-winner" component={SweepWinnerLayout} />}
    {hasPermission('path') && <PrivateRoute path="/reports/pivot-table/impression" component={ImpressionPivotTableLayout} />}
    {hasPermission('offer') && <PrivateRoute path="/reports/pivot-table/session" component={SessionPivotTableLayout} />}
    {hasPermission('cms') && <PrivateRoute path="/reports/ping-check/drilldown" exact component={PingCheckDrilldownLayout} />}
    {hasPermission('cms') && <PrivateRoute path="/reports/ping-check" component={PingCheckLayout} />}
    {hasPermission('cms') && <PrivateRoute path="/reports/rewards" component={RewardsLayout} />}
    {isSuperAdmin && hasPermission('path') && <PrivateRoute path="/reports/custom/:viewId" component={CustomLayout} />}
    {isSuperAdmin && hasPermission('path') && <PrivateRoute path="/reports/custom" exact component={CustomLayout} />}
  </AppRouter>
}

const OrganizationPerformanceLayout = () => <LossesLayout detachedSite title="Organization Performance" />

// Keeps old bookmarks/links working: /reports/losses[/drilldown?configure=...] ->
// /reports/publisher-performance[/drilldown?configure=...] (sub-path and query string preserved).
const LegacyPathRedirect = ({ path, to }) => <Route
  path={path}
  render={({ location }) => <Redirect to={{ ...location, pathname: location.pathname.replace(path, to) }} />}
/>
